import { FC, useContext } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';

const ReadAboutBidding: FC = () => {
  const { isBigScreen } = useContext(ObjectPageContext);
  return (
    <a
      className="inline-flex self-start items-center hover-move-arrow"
      href="/budgivning"
      target={'_blank'}
    >
      <span className="text-tiny text-black500 lg:text-white">
        Läs mer om budgivning
      </span>
      <img
        width="16"
        height="8"
        className="viewing-icon arrow-move ml-2 w-4"
        src={
          isBigScreen
            ? '/Images/Icons/Arrows/arrow-right-white.svg'
            : '/Images/Icons/Arrows/arrow-right-blue700.svg'
        }
        alt="Arrow icon"
      />
    </a>
  );
};
export default ReadAboutBidding;
